<template>
  <div class="class-list">
    <GlobalInfoBar
      title="销售订单管理"
      content="管理或查看已售出的演示机、优品机订单"
    />
    <GlobalChunk icon="search" title="筛选查询">
      <div slot="filter">
        <From/>
      </div>
      <Table/>
    </GlobalChunk>
  </div>
</template>

<script>
import From from "./Form";
import Table from "./Table";
import _api from "@/utils/request";
export default {
  name: "class-list",
  components: {
    From,
    Table
  },
  data() {
    return {
      channelSelectList: [],
      merchantSelectList: [],
      allMerchantSelectList: []
    };
  },
  created() {
    
  },
  methods: {
  },
};
</script>

<style>
</style>